module.exports = {
  Direction: "rtl",
  Header: [
    { label: "דף הבית" },
    { label: "מחיר"},
    { label: "צור קשר"},
    { label: "להתחיל עכשיו"},
  ],
  BusinessPage: [
    { label: "מתנצלים שגיאת שרת לא ניתן לטעון את הדף" },
    { label: "פאנל ניהול" },
    { label: "הזמן תור עכשיו" },
    { label: "שיתוף דף העסק" },
    { label: { item: "לחץ/י כאן להעתקת הקישור", item2: "הקישור הועתק!" } },
    { label: "הסטוריז שלנו" },
    { label: "השירותים שלנו" },
    { label: "תיאור המוצר" }, // ServiceCard
    {
      label: {
        item: "פרטי התור שלך",
        item2: "שלום:",
        item3: "שעת התור שנקבעה:",
        item4: "תאריך שנקבע:",
        item5: "ביטול התור",
        item7: "לא נקבעו תורים לאחרונה",
      },
    }, // UserQueueManagementMenu
    {
      label: {
        item: "רישום קצר",
        item2: "התחברות",
        item3: "שם פרטי",
        item4: "טלפון",
        item5: "כניסה",
        item7: "רישום למערכת",
      },
    }, // UserLoginForm
    {
      label: {
        item: "צריך לבחור איש צוות אחד המועדף עליך",
        item2: "עליך לבחור לפחות סוג שירות אחד",
        item3: "חייב לבחור תאריך",
        item4: "יש צורך לבחור שעה",
        item5: "קביעת תור",
        item7: "לקבוע את התור?",
        item8: "הבא",
        item9: "התור שלך נקבע בהצלחה !",
        item10: "חזרה לדף",
      },
    }, // BookAppoinment
    {
      label: {
        item: "בחר חבר צוות:",
        item2: "בחר סוג שירות:",
        item3: "₪", //price
        item4: "בחר תאריך:",
        item5: "בחר שעה",
        item7: "כל התורים נתפסו בתאריך זה",
        item8: "פרטי התור שנבחרו:",
        item9: "סוג השירות",
        item10: "תאריך",
        item11: "יום",
        item12: "שעה",
        item13: "העובד שנבחר",
      },
    }, // AppoinmentFormSteps

    { label: "פתחו גם דף כזה לקביעת תורים" },
  ],
  CalendarPage: [
    { label: "האם אתה בטוח להזיז את שעות התור ?" },
    { label: { item: "אישור", item2: "ביטול", item3: "בטל תור" } },
    { label: "הכל" }, // setSelectedEmployeeViewQueue
    { label: "he" }, // culture
    { label: "right" }, // textAlign
    {
      label: {
        item: "תאריך התור",
        item2: "שעת התור",
        item3: "סוג אירוע",
        item4: "לא נמצאו תורים בין חודשים אלו",
      },
    }, // messages
    { label: "שיתוף דף העסק" },
    { label: "הוספת תור חדש" },
    {
      label: {
        item: "בחר עובד להצגת התורים שלו",
        item2: "בחר עובד",
        item3: "הכל",
        item4: "תאריך יומי",
        item5: "תאריך שבועי",
        item7: "חזרה להיום",
      },
    }, // CustomToolbar
    {
      label: {
        item: "האם אתה בטוח שברצונך לבטל את התור של הלקוח",
        item2: "פרטי התור",
        item3: "שם לקוח:",
        item4: "שעת התור:",
        item5: "סיום התור:",
        item7: "ביצוע שינויים",
        item8: "עריכה",
        item9: "ביטול",
        item10: "הברזות",
      },
    }, // EventComponent
    {
      label: {
        item: "שדה חובה",
        item2: "סוג שירות",
        item3: "שם הלקוח",
        item4: "בחירת עד שעה",
        item5: "בחירת צבע לזיהוי אירועים",
        item7: "בחירת צבע לזיהוי סוג האירוע",
        item8: "בחירת צבע לזיהוי האירוע",
        item9: "אישור",
      },
    }, // AddEvents

    { label: "פתחו גם דף כזה לקביעת תורים" },
  ],
  SettingsPage: [
    { label: "שעות הפעילות" },
    { label: "הגדרת התורים" },
    { label: "עיצוב דף קבלת התורים" },
    { label: "ניהול הודעות קופצות" },
    { label: "עדכונים ותזכורות" },
    { label: "פרטי העסק" },
    { label: "פרטי המנוי" },
    { label: "הגדרות שפה" },
    { label: "הודעות חשובות ללקוחות" },
    { label: "חזרה לדף הראשי" },
  ],

  DropZoneArea: [
    { label: "הקבצים שכבר התקבלו בהצלחה:" },
    { label: "סה''כ קבצים שהתקבלו:" },
    {
      label:
        "גרור ושחרר קבצים לכאן כדי להעלות. אנחנו יכולים לקבל רק קבצים בגודל של פחות מ-30MB.",
    },
    { label: "בחירת קובץ" },
    { label: "תיאור המוצר תמונה מספר" },
    { label: "אישור" },
    { label: "צפייה בנתונים קיימים" },
    { label: "בחירת צבע של הדף" },
    { label: "בצע" },
    { label: "לוגו" },
    { label: "תמונת רקע הדף" },
    { label: "תמונות סטוריז" },
    { label: "תמונות המוצרים" },
    { label: "ניתן למחוק סטוריז ותמונות מוצרים על ידי לחיצה על תמונה הרצויה" },
    { label: "האם אתה בטוח שברצונך למחוק תמונה זו?" },
    { label: "מחיקה" },
    { label: "ביטול" },
  ],

  
  // components of settings

  WorkingHoures: [
    {label: "יום"},
    {label: "התחלה"},
    {label: "סיום"},
    {label: "ביטול"},
    {label: "מרווח זמנים בין תור לתור:"},
    {label: "בצע שינויים"},
  ],

  SubTitles: [
    {
      title: "הגדרות דף קביעת התורים",
      description: "בחר כיצד אתה רוצה שהמערכת תפעל",
    },
    {
      title: "הגדרת שפת המערכת",
      description: "בחר כיצד אתה רוצה שהמערכת תפעל",
    },
    {
      title: "הגדרות תוכן הודעות הקופצות",
      description: "בחר כיצד אתה רוצה שהודעות הקופצות יפעלו",
      onLabel: "פעיל",
      offLabel: "כבוי",
      TextArea: "תוכן הודעה הקופצת...",
      Label: "בצע",
    },
    {
      title: "הגדרות עדכונים ותזכורות ללקוחות",
      description: "כל הלקוחות במערכת יקבלו הודעה",
      TextArea: "תוכן ההודעה...",
      Label: "שליחת הודעה",
    },
    {
      title: "איזור אישי של פרטי המנוי שלך",
      TextInput: "תאריך חיוב הבא",
      Label: "ביטול המנוי",
      ModalTitle: "האם אתה בטוח שברצונך לבטל את המנוי?",
      confirm: "אישור",
      cancel: "ביטול",
    },
  ],

  TypesOfServices: [
    { label: "רשומות לכל דף" },
    { label: "לא נוספו שירותים" },
    { label: "שם השירות" },
    { label: "זמן השירות" },
    { label: "מחיר השירות" },
    { label: "₪" },
    {
      label: {
        item: "עריכת השירות שנבחר",
        item2: "שם השירות",
        item3: "אורך זמן השירות",
        item4: "מחיר השירות",
        item5: "סוג הצבע ספציפי לסוג השירות",
        item7: "פעיל",
        item8: "כבוי",
        item9: "להסתיר מדף קביעת התורים את השירות",
        item10: "בטוח שברצונך למחוק את הלקוח מהמערכת?",
        item11: "פעולה זו תמחק את כל הנתונים של המשתמש",
        item12: "מחק",
        item13: "ביטול",
        item14: "מחיקת השירות",
        item15: "עדכן פרטים",
      },
    }, // DataEditing
  ],
  CustomersList: [
    { label: "רשומות לכל דף" },
    { label: "לא קיימים לקוחות" },
    { label: "שם הלקוח" },
    { label: "דירוג הלקוח" },
    { label: "אין נתונים קיימים" },
    {
      label: {
        item: "פרטי הלקוח",
        item2: "פעולות נוספות",
        item3: "נתוני הלקוח",
        item4: "שם הלקוח",
        item5: "טלפון",
        item7: "פעיל",
        item8: "כבוי",
        item9: "חסימת לקוח",
        item10: "בטוח שברצונך למחוק את הלקוח מהמערכת?",
        item11: "פעולה זו תמחק את כל הנתונים של המשתמש",
        item12: "מחק",
        item13: "ביטול",
        item14: "מחיקת הלקוח מהמערכת",
        item15: "עדכן פרטים",
        item16: "איחורים:",
        item17: "ביטולים:",
        item18: "פגישות:",
      },
    }, // DataEditing
  ],
  ListMembers: [
    { label: "רשומות לכל דף" },
    { label: "אין עובדים קיימים" },
    { label: "שם העובד" },
    { label: "טלפון" },
    { label: "הוספת עובד" },
    {
      label: {
        item: "בחרת",
        item2: "להסרה עובד אחד",
        item3: "עובדים להסרה",
        item4: "בחירת רשומת עובד להסרה",
      },
    },
    {
      label: {
        item: "עריכת כרטיסיית עובד",
        item2: "פרטים",
        item3: "שעות הפעילות",
        item4: "שם העובד",
        item5: "טלפון",
        item7: "פעיל",
        item8: "כבוי",
        item9: "ביטול קבלת תורים לעובד זה",
        item11: "עדכן פרטים",
      },
    }, // FormModal
    {
      label: {
        item: "הוספת עובד למערכת",
        item2: "שם העובד",
        item3: "טלפון",
        item4: "אישור",
      },
    }, // FormAddEmployee
  ],
  SubscriptionPurchasePage: [
    { label: "50 ש''ח כולל מע''מ" },
    { label: "מיתוג ועיצוב דף העסק" },
    { label: "מערכת חכמה לקביעת תורים" },
    { label: "דירוג לקוחות וסטטיסטיקה" },
    { label: "ניהול הודעות אוטומטיות ללקוחות" },
    { label: "יומן דיגטלי" },
  ],
  PaymentSummaryPage: [
    { label: "התשלום בוצע בהצלחה" },
    { label: "התחבר מחדש" },
    { label: "מתנצלים, אך התשלום לא עבר בהצלחה" },
    { label: "נסה לבצע תשלום שנית" },
  ],
  ExpiredZone: [
    { label: "המנוי שלך פג תוקף" },
    { label: "על מנת להמשיך עליך לחדש את המנוי" },
    { label: "פג תוקף" },
    { label: "המנוי פג תוקף" },
    { label: "אופס.. נראה שתוקף המנוי שלך צריך לחדש 😄" },
    { label: "לחידוש המנוי" },
  ],
  CreateBusinessAccount: [
    { label: "שם פרטי ומשפחה חייב לכלול לפחות 6 אותיות" },
    { label: "מס' טלפון חייב להכיל לפחות עשרה ספרות כולל קידומת" },
    { label: "הסיסמא חייבת להכיל לפחות 7 תווים" },
    { label: "יש צורך לאשר מדיניות פרטיות" },
    { label: "דוא''ל לא חוקי" },
    { label: "יצירת משתמש" },
    {},
    {
      inputs: {
        item: "שם פרטי ומשפחה",
        item2: "מס' טלפון",
        item3: "דוא''ל",
        item4: "סיסמא",
        item5: "אני מאשר",
        item7: "את התנאים ומדיניות הפרטיות",
        item8: "פרופיל העסק",
        item9: "טלפון בית העסק",
        item10: "שם העסק",
        item11: "כתובת העסק",
        item12: "סוג הצבע לדף העסק שלך",
        item13: "קביעת התורים",
        item14: "הוספת שירותים",
        item15: "חזרה",
        item17: "שלב הבא",
        item18: "יצירת דף העסק",
        //AddNewtodoList.js
        item19: "סוג השירות",
        item20: "זמן השירות",
        item21: "מחיר",
        item22: "לחצו על הכפתור כדי להוסיף שירות",
        item23: "יש צורך להוסיף שירות אחד לפחות",
        item24: "הוספת שירות",
      },
    },
    // SuccessPages/SuccessCreateAccount
    { label: "סיימנו להקים את דף ניהול התורים שלך!" },
    { label: "להתחבר למערכת" },
  ],
  MainPage: [
    { label: "כניסה" },
    { label: "יצירת חשבון" },
    {
      inputs: {
        item: "מס' טלפון",
        item2: "סיסמא",
        item3: "התחבר",
        item4: "מדיניות הפרטיות",
      },
    },
  ],
  PaymentMethodDetailCard: [
    { label: "יומן חכם" },
    { label: "מיתוג ועיצוב דף העסק" },
    { label: "קביעת תורים ותזכורות" },
    { label: "דירוג לקוחות וסטטיסטיקה" },
    { label: "1200 הודעות SMS" },
    
    { label: "אוטומציית קביעת תורים אוטומטית" },
    { label: "הודעות WhatsApp ללא הגבלה" },
    { label: "רשימת המתנה" },
    { label: "סליקת אשראי מלקוחות"},
    { label: "מס' עובדים ללא הגבלה" },
    { label: "גישה מלאה ללא הגבלה" },
    { label: "התנסו עם 14 ימי ניסיון" },
    {
      inputs: {
        item: "מס' טלפון",
        item2: "סיסמא",
        item3: "התחבר",
        item4: "מדיניות הפרטיות",
      },
    },
  ],

  ContactSection: [
    {title: "צרו קשר איתנו ונדאג לחזור אליכם בהקדם"},
    {SubTitle: "נשמח לספק תמיכה או מענה לכל שאלה"},
    {label: "הסבר מלא ומפורט בשימוש המערכת"},
    {label: "איך להתאים את המערכת לצרכי העסק שלך"},
    {label: "להבין בדיוק איך המערכת תעזור לעסק שלך לצמוח"},
    {Email: "דוא''ל"},
    {Phone: "טלפון"},
    {Address: "כתובת משרד"},
    {WorkingHours: "שעות פעילות"},
  ]
};
